import * as ActionCreators from './actionCreators';
//import { methodConstants } from '../constants/methodConstants';
import * as Http from '../api/http';
import * as ErrorActions from './errorActions';
import * as CommonActions from './commonActions';
import { appConstants } from '../constants/appConstants';
import { getLayouts } from './defaultActions';

export const createPrivacyLink = (locale) => (dispatch) => {
  const localeTable = {
    en: 'en_US',
    ja: 'ja_JP',
    zh: 'zh_CN',
    fr: 'fr_FR',
    es: 'es_ES',
    pt: 'pt_PT',
    it: 'it_IT',
    de: 'de_DE',
    nl: 'nl_NL',
    ar: 'ar_SA',
    'en-US': 'en_US',
    'en-GB': 'en_GB',
    'fr-FR': 'fr_FR',
    'fr-CA': 'fr_CA',
    'es-MX': 'es_MX',
    'es-ES': 'es_ES',
    'pt-PT': 'pt_PT',
    'pt-BR': 'pt_BR',
    'it-IT': 'it_IT',
    'de-DE': 'de_DE',
    'nl-NL': 'nl_NL',
    'zh-CN': 'zh_CN',
    'zh-HK': 'zh_HK',
    'ar-SA': 'ar_SA',
    'ja-JP': 'ja_JP'
  };
  const privacyPolicyLink = `//www.awardselect.com/privacy/p_${
    localeTable[locale]
  }.html`;

  dispatch(ActionCreators.updatePrivacyPolicyLink(privacyPolicyLink));
};

export const creatTranslations = () => (dispatch) =>{
  const translationData = {
    'my-account-mobile-device-title':'Mobile Devices',
    'my-account-mobile-device-generate-pair-code-button':'Generate Pairing Code',
    'my-account-mobile-device-message-text':'It will expire after a few minutes. You can generate a new code any time.',
    'my-account-mobile-device-pair-device-title':'My Devices'
  };
  dispatch(ActionCreators.translations(translationData));
};

function translateArray(data, trans){
  return data.map( item => {
    item = trans[item];
    return item;
  });
}

export const monthsWeeks = (trans) => (dispatch) => {
  const calendarLabels = CommonActions.deepClone(appConstants.DATE_PICKER_LABELS);
  calendarLabels.nextMonth = trans[calendarLabels.nextMonth];
  calendarLabels.previousMonth = trans[calendarLabels.previousMonth];
  const obj = {
    monthsFull: translateArray(appConstants.MONTHS_FULL, trans),
    smallWeeks: translateArray(appConstants.WEEKS_SMALL, trans),
    dayPickerLabels: calendarLabels
  };
  dispatch(ActionCreators.monthsWeeks(obj));
  CommonActions.setMonthsWeeksLocalization(trans, true);
};

export const getTranslations = (isLangChanged) => (dispatch, getState) => {
  const currentState = getState();
  //const translationsUrl = CommonActions.getFullApiUrl(methodConstants.GET_TRANSLATIONS, currentState);
  const translationsUrl = currentState.translationApiUrl;
  Http.get(translationsUrl, currentState).then((res) => {
    dispatch(ActionCreators.translations(res));
    dispatch(monthsWeeks(res));
    dispatch(createPrivacyLink(currentState.locale));
    dispatch(ActionCreators.changeLocale(currentState.locale));
    if (isLangChanged) {
      dispatch(getLayouts());
    }
  }).catch((err) => {
    dispatch(ErrorActions.displayError(err));
  });
  // }
};
